<template>
  <div class="row justify-content-around ml-0 mr-0">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
